<template>
	<div id="login">
		<div class="wrap">
			<div class="logo">
				<span></span>微信小程序路由代理服务中心
			</div>
			<div class="login-right">
				<el-form :model="loginData" ref="loginForm" :rules="loginFormRules">
					<div class="top-line"></div>
					<h2>登录</h2>
					<div class="user-name">
						<el-form-item prop="username">
							<el-input placeholder="用户名" v-model="loginData.username" auto-complete="off">
								<i slot="prefix" class="iconfont icon-icon-name"></i>
							</el-input>
						</el-form-item>
					</div>
					<div class="user-password">
						<el-form-item prop="password">
							<el-input placeholder="登录密码" type="password" v-model="loginData.password" auto-complete="off">
								<i slot="prefix" class="iconfont icon-icon-lock"></i>
							</el-input>
						</el-form-item>
					</div>
					<div class="user-rember-password">
						<el-checkbox v-model="remberUser">记住用户名和密码</el-checkbox>
					</div>
					<div class="valid-button">
						<el-button type="primary" @click="login('loginForm')" id="keybtn" :loading="loading">登录{{loading?'中':''}}</el-button>
					</div>
				</el-form>

			</div>
			<div class="login-left"></div>
			<div class="copyright">版本号信息：{{g_Config.versionNo}}</div>
		</div>
	</div>
</template>
<script>
	import utils from 'main/utils/util';
	import loginServer from 'main/service/login';
	import Cookies from 'js-cookie';
	import {setAccessToken, setAuthTree} from 'main/utils/auth';

	export default {
		name: 'login',
		data() {
			return {
				loading: false,
				loginData: {
					username: Cookies.get('username') ? Cookies.get('username') : '',
					password: Cookies.get('password') ? Cookies.get('password') : ''
				},
				remberUser: false, // 记住密码
				loginFormRules: {
					username: [
						{required: true, message: '用户名不能为空', trigger: 'blur'}
					],
					password: [
						{required: true, message: '密码不能为空', trigger: 'blur'}
					]
				}
			};
		},
		created() {
			// 如果之前选了记住密码，则重新进入这个页面需要记住密码被勾选
			let username = Cookies.get('username');
			let password = Cookies.get('password');
			if (username && password) {
				this.remberUser = true;
			} else {
				this.remberUser = false;
			}
		},
		mounted() {
			let _this = this;
			utils.quickSearch('login-right', function(){
				_this.login('loginForm');
			});
		},
		methods: {
			/**
			 * 验证用户名密码是否都正确，去请求后台
			 * @param formName
			 */
			login(formName) {
				this.$refs[formName].validate(valid => {
					if (valid) {
						this.loading = true;
						// 再去获取token
						let params = {
							account: this.loginData.username,
							password: this.loginData.password
						};
						loginServer.login(params).then(res => {
							setAccessToken(res.token); // 往sessionStorage存放'jwt_token'的值
							// 如果选了记住密码
							if (this.remberUser) {
								Cookies.set('username', this.loginData.username, { expires: 30 }); // 不设置cookie过期时间默认会话关闭即过期，现在是30天过期
								Cookies.set('password', this.loginData.password, { expires: 30 }); // 不设置cookie过期时间默认会话关闭即过期，现在是30天过期
							} else {
								Cookies.remove('username');
								Cookies.remove('password');
							}
							window.sessionStorage.setItem('userName', this.loginData.username);
							loginServer.getAuthTree().then(res => {
								this.loading = false;
								setAuthTree(res);
								document.onkeypress = '';
								this.$router.push({path: '/icmp/'}); // 跳转到系统首页
							}).catch(err => {
								this.loading = false;
								this.$message.error(err);
							});
						}).catch(err => {
							this.loading = false;
							this.$message.error(err);
						});
					}
				});
			}
		}
	};
</script>
<style lang="scss" scoped>
	#login {
		margin: 0;
		padding: 0;
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		width: 100%;
		height: 100%;
		background-color: #f2f6fc;
		@media screen and (min-width: 1920px) {
			/deep/ .wrap {
				width: 1660px;
				height: 800px;
				position: absolute;
				top: 50%;
				left: 50%;
				margin-left: -830px;
				margin-top: -400px;
				.logo {
					display: flex;
					align-items: center;
					font-size: 16px;
					color: #7c889c;
					position: absolute;
					top: -50px;
					left: 0;
					span {
						display: inline-block;
						width: 38px;
						height: 38px;
						background: url('../../assets/img/login/logo.jpg') no-repeat;
						background-size: auto 100%;
						margin-right: 14px;
					}
				}
				.login-left {
					width: 688px;
					height: 100%;
					position: absolute;
					right: 0;
					background: url('../../assets/img/login/login.png') no-repeat;
					background-size: auto 100%;
				}
				.login-right {
					width: 972px;
					height: 100%;
					position: absolute;
					left: 0;
					background-color: #fff;
					.el-form {
						width: 500px;
						margin: 0 auto;
						.top-line {
							width: 18px;
							height: 3px;
							background-color: #3860f4;
							border-radius: 1.5px;
							margin-top: 176px;
						}
						h2 {
							height: 33px;
							line-height: 33px;
							font-size: 24px;
							font-weight: 400;
							color: #252525;
							margin-top: 5px;
							margin-bottom: 27px;
						}
						.el-input__inner {
							height: 60px;
							padding-left: 67px;
							border: 1px solid #e1e1e3;
							box-shadow: inset 0 0 3px 0 #aeaeae;
							background-color: #fafafc;
						}
						.el-input__prefix {
							left: 25px;
							top: 10px;
							color: #567bec;
						}
						.el-form-item__error {
							left: 22px;
							top: 67px;
							text-align: right;
						}
						.user-rember-password {
							margin-top: 15px;
							text-align: left;
							font-size: 12px;
							color: #575A5F;
							line-height: 20px;
						}
						.not-valid-button {
							margin-top: 69px;
							.el-button {
								height: 46px;
								background: #E7EAF3;
								border-radius: 4px;
								border: none;
							}
						}
						.valid-button {
							margin-top: 20px;
							.el-button {
								width: 100%;
								height: 46px;
								background: #4B73EB;
								border-radius: 4px;
								border: none;
							}
						}
					}
				}
				.copyright {
					font-size: 18px;
					color: #b2bbcb;
					position: absolute;
					bottom: -30px;
					left: 48%;
				}
			}
		}
		@media screen and (max-width: 1900px) {
			/deep/ .wrap {
				width: 1200px;
				height: 560px;
				position: absolute;
				top: 50%;
				left: 50%;
				margin-left: -600px;
				margin-top: -280px;
				.logo {
					display: flex;
					align-items: center;
					font-size: 16px;
					color: #7c889c;
					position: absolute;
					top: -50px;
					left: 0;
					span {
						display: inline-block;
						width: 30px;
						height: 30px;
						background: url('../../assets/img/login/logo.jpg') no-repeat;
						background-size: auto 100%;
						margin-right: 14px;
					}
				}
				.login-left {
					width: 500px;
					height: 100%;
					position: absolute;
					right: 0;
					background: url('../../assets/img/login/login.png') no-repeat;
					background-size: auto 100%;
				}
				.login-right {
					width: 700px;
					height: 100%;
					position: absolute;
					left: 0;
					background-color: #fff;
					.el-form {
						width: 400px;
						margin: 0 auto;
						.top-line {
							width: 18px;
							height: 3px;
							background-color: #3860f4;
							border-radius: 1.5px;
							margin-top: 100px;
						}
						h2 {
							height: 33px;
							line-height: 33px;
							font-size: 24px;
							font-weight: 400;
							color: #252525;
							margin-top: 5px;
							margin-bottom: 27px;
						}
						.el-input__inner {
							height: 40px;
							padding-left: 50px;
							border: 1px solid #e1e1e3;
							box-shadow: inset 0 0 3px 0 #aeaeae;
							background-color: #fafafc;
						}
						.el-input__prefix {
							left: 20px;
							top: 2px;
							color: #567bec;
						}
						.el-form-item__error {
							left: 22px;
							top: 45px;
							text-align: right;
						}
						.user-rember-password {
							margin-top: 15px;
							text-align: left;
							font-size: 12px;
							color: #575A5F;
							line-height: 20px;
						}
						.not-valid-button {
							margin-top: 69px;
							.el-button {
								height: 46px;
								background: #E7EAF3;
								border-radius: 4px;
								border: none;
							}
						}
						.valid-button {
							margin-top: 20px;
							.el-button {
								width: 100%;
								height: 46px;
								background: #4B73EB;
								border-radius: 4px;
								border: none;
							}
						}
					}
				}
				.copyright {
					font-size: 16px;
					color: #b2bbcb;
					position: absolute;
					bottom: -30px;
					left: 48%;
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// main/view/login/Login.vue